import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../LanguageContext';

export default function SEO({ title, description }) {
  const { lang } = useLanguage();
  const defaultImage = "https://ironwood.ge/seo_share.webp";
  const pathname = window.location.pathname;
  const url = `https://ironwood.ge${pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      
      {/* Multilingual Support - Signaling that both versions exist on this URL */}
      <link rel="alternate" hrefLang="ka" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={defaultImage} />
      <meta property="og:locale" content={lang === 'ge' ? 'ka_GE' : 'en_US'} />
      <meta property="og:locale:alternate" content={lang === 'ge' ? 'en_US' : 'ka_GE'} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={defaultImage} />
    </Helmet>
  );
}

